import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import RatingComponent from 'pages/HousePage/HouseComponents/RatingComponent';
function Rating({ title, rating }) {
    return (_jsx(_Fragment, { children: _jsx(RatingComponent, { title: title, rating: rating, cardSize: "s" }) }));
}
export default Rating;
